import React, { useState, useEffect } from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { api } from "../../../utils/Api";
import { useParams } from "react-router-dom";

const initial_value = {
  service_id: "",
  quantity: "",
  gst: false,
  // have_d_or_p: "none",
  // discount_type: "amount",
  // discount_amount: "",
  // discount_percent: "",
  // profit_type: "amount",
  // profit_amount: "",
  // profit_percent: "",
};

export default function ModalUpdateService(props: any) {
  const [save_data, SetSaveData] = useState(initial_value);
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [is_open, SetIsOpen] = useState(false);
  const [id_value, SerIdValue] = useState(useParams());
  const [service_data, SetServiceData] = useState({});
  const [gst_percent, SetGstPercent] = useState("");

  useEffect(() => {
    console.log("ModalUpdateService close data :", close_data);
  }, []);

  useEffect(() => {
    if (props.isOpen) {
      console.log("ModalUpdateService On Open :", props);
      SetIsOpen(props.isOpen);
      SetServiceData(props.data.service_data);
      SetGstPercent(props.gst_percent);
      SetSaveData((prevValue) => {
        prevValue.service_id = props.data.service_data.id;
        if (props.data.service_data.hasOwnProperty("price")) {
          prevValue.quantity = props.data.service_data.price.quantity;
        }
        if (props.data.service_data.hasOwnProperty("gst")) {
          prevValue.gst = props.data.service_data.gst;
        }
        if (props.data.service_data.price.hasOwnProperty("gst_amount")) {
          prevValue.gst_amount = props.data.service_data.price.gst_amount;
        }
        if (props.data.service_data.price.hasOwnProperty("total_amount")) {
          prevValue.total_amount = props.data.service_data.price.total_amount;
        }
        if (props.data.service_data.price.hasOwnProperty("amount")) {
          prevValue.amount = props.data.service_data.price.amount;
        }

        return { ...prevValue };
      });
    }
  }, [props.isOpen]);

  async function update_service() {
    let pass_data_value = {
      service_id: save_data.service_id,
      quantity: save_data.quantity,
      gst: save_data.gst,
      amount: save_data.amount,
    };

    console.log("pass_data_value :", pass_data_value);
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
        order_id: props.data.order_id,
      },
      post: pass_data_value,
    };
    let data_res = await api("/outlet/update_service_quantity_v2", pass_data);
    console.log("update_service_quantity_v2 response :", data_res.response);
    if (data_res.response.hasOwnProperty("order_services")) {
      let item = close_data;
      item.action = "save";
      item.service_data = data_res.response.order_services;
      SetCloseData(item);
      SetIsOpen(false);
      SetSaveData(initial_value);
      props.close(close_data);
    }
  }

  const Switch = ({ isOn, handleToggle, onColor }) => {
    return (
      <>
        <input
          checked={isOn}
          onChange={handleToggle}
          className="react-switch-checkbox"
          id={`react-switch-new`}
          type="checkbox"
        />
        <label
          style={{ background: isOn && onColor }}
          className="react-switch-label"
          htmlFor={`react-switch-new`}
        >
          <span className={`react-switch-button`} />
        </label>
      </>
    );
  };

  return (
    <div>
      <SlidingPane
        className="some-custom-class"
        overlayClassName="some-custom-overlay-class"
        isOpen={is_open}
        title="Update Service"
        onRequestClose={() => {
          console.log("close");
          let item = close_data;
          item.action = "close";
          SetCloseData(item);
          SetIsOpen(false);
          props.close(close_data);
        }}
        from="right"
        width="500px"
      >
        <div className="row">
          <div className="pt-0 pe-0">
            <div className="d-flex mb-2">
              <h5>{service_data.service_name}</h5>
              <div className="ms-auto">
                <button
                  className="btn btn-light-outline ms-2 btn-sm"
                  onClick={() => {
                    console.log("Update service save data :", save_data);
                    update_service();
                  }}
                >
                  Update
                </button>
              </div>
            </div>
            <div className="row">
              {/* Quantity */}
              <div className="col-md-6 mt-3">
                <label className="form-label">Quantity / Duration</label>
                <input
                  type="text"
                  className="form-control"
                  value={save_data.quantity}
                  onChange={(e) => {
                    SetSaveData((prevValue) => {
                      let gst_amount_value,
                        total_amount_value,
                        entered_amount,
                        entered_quantity;
                      let price = props.data.service_data.update_service.price;
                      let price_quantity =
                        props.data.service_data.update_service.price_quantity;
                      let service_price = parseFloat(price / price_quantity);
                      entered_quantity = e.target.value;
                      entered_amount = parseFloat(
                        service_price * entered_quantity
                      );
                      gst_amount_value = (gst_percent / 100) * entered_amount;
                      if (save_data.gst) {
                        total_amount_value =
                          parseFloat(gst_amount_value, 2) +
                          parseFloat(entered_amount, 2);
                      } else {
                        total_amount_value = entered_amount;
                      }
                      prevValue.quantity = entered_quantity;
                      prevValue.amount = entered_amount;
                      prevValue.gst_amount = gst_amount_value;
                      prevValue.total_amount = total_amount_value;

                      return { ...prevValue };
                    });
                  }}
                />
              </div>
              {/* GST */}
              <div className="col-md-6 mt-3">
                <label className="form-label">GST</label>
                <Switch
                  isOn={save_data.gst}
                  onColor="#06D6A0"
                  handleToggle={(e) => {
                    console.log("Switch on change :", e);
                    SetSaveData((prevValue) => {
                      prevValue.gst = !prevValue.gst;
                      let gst_amount_value, total_amount_value, entered_amount;
                      if (prevValue.amount != "") {
                        entered_amount = prevValue.amount;
                      } else {
                        entered_amount = 0;
                      }
                      gst_amount_value = parseFloat(
                        (gst_percent / 100) * entered_amount,
                        2
                      );
                      if (prevValue.gst) {
                        total_amount_value =
                          parseFloat(gst_amount_value, 2) +
                          parseFloat(entered_amount, 2);
                      } else {
                        total_amount_value = entered_amount;
                      }
                      prevValue.gst_amount = gst_amount_value;
                      prevValue.total_amount = total_amount_value;
                      return { ...prevValue };
                    });
                  }}
                />
              </div>
              {/* Amount */}
              <div className="col-md-6 mt-3">
                <label className="form-label">Amount</label>
                <input
                  type="text"
                  className="form-control"
                  value={save_data.amount}
                  onChange={(e) => {
                    SetSaveData((prevValue) => {
                      let gst_amount_value, total_amount_value, entered_amount;
                      entered_amount = e.target.value;
                      gst_amount_value = (gst_percent / 100) * entered_amount;
                      if (prevValue.gst) {
                        total_amount_value =
                          parseFloat(gst_amount_value, 2) +
                          parseFloat(entered_amount, 2);
                      } else {
                        total_amount_value = entered_amount;
                      }
                      prevValue.amount = entered_amount;
                      prevValue.gst_amount = gst_amount_value;
                      prevValue.total_amount = total_amount_value;

                      return { ...prevValue };
                    });
                  }}
                />
              </div>
              {/* GST Amount */}
              {save_data.gst ? (
                <div className="col-md-6 mt-3">
                  <label className="form-label">GST Amount</label>
                  <input
                    type="text"
                    className="form-control"
                    value={save_data.gst_amount}
                    disabled={true}
                  />
                </div>
              ) : null}
              {/* Total Amount */}
              <div className="col-md-6 mt-3">
                <label className="form-label">Total Amount</label>
                <input
                  type="text"
                  className="form-control"
                  value={save_data.total_amount}
                  disabled={true}
                />
              </div>
            </div>
          </div>
        </div>
      </SlidingPane>
    </div>
  );
}
